import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useHistory } from 'react-router';

import styles from './style.module.scss';
import { submitSpecialOffers, getEmployeeInfo } from 'src/api';
import { goBack, gaTrackingAndLogAction, handleGoBack, showError } from 'src/utils';
import {
    SPECIAL_OFFERS_DETAIL_URL,
    ON_TO_OFF_TRACKING,
    ON_TO_OFF_STEP,
    ON_TO_OFF,
    CAMPAIGN_CODES,
    ON_TO_OFF_ACTION_TYPE,
    VALIDATE_RM_CODE,
} from 'src/constants';

import InsurancePackageIcon from 'src/assets/special_offers_icon_1.png';
import InsuranceRefundIcon from 'src/assets/special_offers_icon_2.png';
import InsuranceBenefitIcon from 'src/assets/special_offers_icon_3.png';
import Checkbox from 'src/components/Checkbox';
import Button from 'src/components/Button';
import LoadingService from 'src/utils/LoadingService';
import PopupConfirm from 'src/components/PopupConfirm';
import LargeCheckWhite from 'src/assets/large_white_check.png';
import TextInput from 'src/components/TextInput';
import Toolbar from 'src/components/Toolbar';

const SpecialOffers = props => {
    const { t } = useTranslation();
    const history = useHistory()
    const [isAgreeGetAdvise, setIsAgreeGetAdvise] = useState(false);
    const [isShowSuccessModal, setShowSuccessModal] = useState(false);
    const [isShowErrorModal, setShowErrorModal] = useState(false)
    const [prevRmCode, setPrevRmCode] = useState("");
    const [rmCode, setRmCode] = useState("");
    const [rmName, setRmName] = useState("");
    const [disableRmName, setDisableRmName] = useState(false);
    const [isShowRMName, setIsShowRMName] = useState(false);
    const [errorRMCode, setErrorRMCode] = useState("");
    const [errorRMName, setErrorRMName] = useState("");
    const closeSuccessModal = useCallback(() => {
        setShowSuccessModal(false)
        document.body.style.overflow = 'unset';
        goBack()
    }, [])

    const handleSubmit = () => {
        if(rmCode && !rmName) {
            setErrorRMName(t('special_offers_rm_name_required'));
            return;
        }
        else {
            setErrorRMName("")
        }
        
        LoadingService.instance.current.open();

        gaTrackingAndLogAction({
            pub: ON_TO_OFF_TRACKING,
            event: ON_TO_OFF[ON_TO_OFF_STEP.CONFIRM],
            eventDirectory: CAMPAIGN_CODES.EXISTING_CUSTOMER,
            actionType: ON_TO_OFF_ACTION_TYPE,
        });

        submitSpecialOffers(rmCode, rmName).then(res => {
            setShowSuccessModal(true)
        }).catch(error => {
            setShowErrorModal(true)
        }).finally(() => {
            LoadingService.instance.current.close();
        })
        
    }

    const handleViewDetail = (e) => {
        e.preventDefault();
        gaTrackingAndLogAction({
            pub: ON_TO_OFF_TRACKING,
            event: ON_TO_OFF[ON_TO_OFF_STEP.VIEW_DETAIL],
            eventDirectory: CAMPAIGN_CODES.EXISTING_CUSTOMER,
            actionType: ON_TO_OFF_ACTION_TYPE,
        }).finally(() => {
            window.location.href = SPECIAL_OFFERS_DETAIL_URL;
        });
    };

    const handleChangeRmCode = (e) => {
        let value = e.target.value.slice(0, 10);
        setRmCode(value);
    };

    const handleBlurRmCode = (e) => {
        if (!isRmCodeValid) {
            setErrorRMCode(t('special_offers_rm_code_invalid'));
            return;
        }
        setErrorRMCode("");
        setIsShowRMName(true);
        setErrorRMName("");
        const findEmployeeInfo = async (rmCode) => {
            try {
                LoadingService.instance.current.open();
                let employeeInfoRes = await getEmployeeInfo(rmCode);
                if(employeeInfoRes?.data?.name) {
                    setRmName(employeeInfoRes?.data?.name);
                    setDisableRmName(true);
                } else {
                    setRmName('');
                    setDisableRmName(false);
                }
            } catch (error) {
                showError(error?.response?.data?.error_message);
            } finally {
                LoadingService.instance.current.close();
            }
        }
        
        let value = e.target.value?.trim()?.toUpperCase();
        setRmCode(value);
        if(value && prevRmCode !== value){
            setPrevRmCode(value);
            findEmployeeInfo(value);
        }else if(!value){
            setPrevRmCode('');
            setRmName('');
            setDisableRmName(false);
        }

        if(!value) {
            setIsShowRMName(false);
        }
    };

    const handleChangeRmName = (e) => {
        setRmName(e.target.value?.slice(0, 100));
    }

    const handleBlurRmName = (e) => {
        setRmName(e.target.value?.trim());
    }

    const isRmCodeValid = useMemo(() => {
        const rmCodeValue = rmCode.trim();
        return VALIDATE_RM_CODE.test(rmCodeValue);
    }, [rmCode]); 

    return <div>
        <Toolbar
            title={t('product_detail')}
            onBack={() => handleGoBack(history)}
        />
        <div className={styles.header}></div>
        <div className={styles.container}>
            <div className={classNames(styles.sectionHeader, 'mb-2')}>
                <img src={InsurancePackageIcon} alt={t("insurance_package")} className="mr-3" />
                <div>
                    <h1>
                        {t("insurance_package")}
                    </h1>
                    <h2>{t("special_offers_insurance_price_ads")}</h2>
                </div>
            </div>
            <div className={styles.sectionHeader}>
                <img src={InsuranceRefundIcon} alt={t("insurance_package")} className="mr-3" />
                <div>
                    <h1>
                        {t("huge_refund")}
                    </h1>
                </div>
            </div>
            <hr />
            <div className={styles.listDetail}>
                <ul>
                    <li>
                        {t('cashback')} <b>15%</b> {t('special_offers_safety_insurance')}
                    </li>
                    <li>
                        {t('special_offers_refund_1')} {' '}
                        <b>{t('x_millions', { value: 200 })}</b>
                    </li>
                    <li>
                        {t('special_offers_lucky_draw')} <b>{t('x_millions', { value: 720 })}</b>
                    </li>
                </ul>
            </div>
            <div className={styles.sectionHeader}>
                <img src={InsuranceBenefitIcon} alt={t("insurance_benefit")} className="mr-3" />
                <div>
                    <h1>
                        {t("insurance_benefit")}
                    </h1>
                </div>
            </div>
            <hr />
            <div className={styles.listDetail}>
                <ul>
                    <li>
                        {t("special_offers_accident_benefits_up_to")} <b>{t('x_millions_years', { value: 10 })}</b> 
                    </li>
                    <li>
                        {t("special_offers_inpatient_benefits_up_to")} <b>{t('x_millions_years', { value: 150 })}</b>
                    </li>
                    <li>
                        {t("special_offers_outpatient_benefits_up_to")} <b>{t('x_millions_years', { value: 4 })}</b>
                    </li>
                    <li>
                        {t("special_offers_death_benefit")} <b>{t('x_millions', { value: 100 })}</b> {t("special_offers_up_to")}
                    </li>
                    <li>
                        {t("special_offers_death_benefit_pay_more")} <b>{t('x_billions', { value: 1 })}</b>
                    </li>
                </ul>
            </div>
            <div className={styles.sectionHeader}>
                <div className={styles.rmCodeDiv}>
                    <h1>
                        {t("special_offers_rm_code_label")}
                    </h1>
                </div>
            </div>
            <hr />
            <div className={classNames("p-4", styles.inputContainer)}>
                <TextInput
                    label={null}
                    placeholder={t('special_offers_rm_code_hint')}
                    value={rmCode}
                    onChange={handleChangeRmCode}
                    onBlur={handleBlurRmCode}
                    maxLength={10}
                    containerClassName="input-focus-gray"
                    error={Boolean(errorRMCode)}
                    helperText={errorRMCode}
                />
            </div>
            {
                isShowRMName &&  (
                    <div className={classNames("pt-0 pb-4 px-4", styles.inputContainer)}>
                        <TextInput
                            label={null}
                            placeholder={t('special_offers_rm_name_hint')}
                            value={rmName}
                            onChange={handleChangeRmName}
                            onBlur={handleBlurRmName}
                            disabled={disableRmName}
                            error={Boolean(errorRMName)}
                            helperText={errorRMName}
                            isRequired={isShowRMName}
                            containerClassName="input-focus-gray"
                            maxLength={100}
                        />
                    </div>
                )
            }
         
            <div className='px-4 py-3'>
                <div className={classNames('flex', styles.agreeConfirmContainer, isAgreeGetAdvise && styles.isAgree)}>
                    <div>
                        <Checkbox className={styles.borderCheckbox} checked={isAgreeGetAdvise} onCheck={() => {
                            if (!isAgreeGetAdvise) {
                                gaTrackingAndLogAction({
                                    pub: ON_TO_OFF_TRACKING,
                                    event: ON_TO_OFF[ON_TO_OFF_STEP.CHECKBOX],
                                    eventDirectory: CAMPAIGN_CODES.EXISTING_CUSTOMER,
                                    actionType: ON_TO_OFF_ACTION_TYPE,
                                });
                            }
                            setIsAgreeGetAdvise(!isAgreeGetAdvise);
                        }} />
                    </div>
                    <label htmlFor='agreeAdvise'
                        onClick={() => setIsAgreeGetAdvise(!isAgreeGetAdvise)}>{t("special_offers_agree_get_advise")}</label>
                </div>
            </div>
            <hr />
            <div className={classNames("flex justify-center pt-3 px-4", styles.buttonDiv)}>
                <Button text={t("confirm")} extraClassName={styles.confirmBtn}
                    onClick={handleSubmit} disabled={!isAgreeGetAdvise}></Button>
            </div>
        </div>
        <PopupConfirm visible={isShowSuccessModal} icon={LargeCheckWhite}>
            <div className='py-5'>
                <p className={classNames('text-center mb-10', styles.successMessage)}>
                    {t("special_offers_success_message_1")} <b>
                        "{t("special_offers_success_message_2")}"</b>. {t("special_offers_success_message_3")}
                </p>
                <Button text={t("close")} extraClassName='w-full' onClick={closeSuccessModal}></Button>
            </div>
        </PopupConfirm>
        <PopupConfirm 
            showIcon={false}
            visible={isShowErrorModal} 
            okTitle={t("close")} 
            title={t("notification")} 
            onOk={() => setShowErrorModal(false)} 
            content={t("general_error")} 
        />
    </div >
}

export default SpecialOffers
